import { jsx as _jsx } from "react/jsx-runtime";
import { ZeroState } from '@sas/nova-commons/components/ZeroState';
import { useI18n } from '../../locale/I18nContext';
import { ZeroStateReport } from '@sas/react-svg';
import { useDesignTokens } from '@sas/nova-commons/theme';
import cn from './ReportSectionZeroState.css.json';
import './ReportSectionZeroState.css';
export const ReportSectionZeroState = (props) => {
    const localize = useI18n();
    const dt = useDesignTokens();
    const { emptyViewEditable, hideAutoChartButton, onPressCreateAutoChart, onPressSelectTemplate, onPressExploreSuggestions, } = props;
    if (emptyViewEditable) {
        const autoChartButtonProps = {
            text: localize({ key: 'ReportSectionZeroState.autoChartButton.label' }),
            onPress: () => {
                onPressCreateAutoChart === null || onPressCreateAutoChart === void 0 ? void 0 : onPressCreateAutoChart();
            },
        };
        const templateButtonProps = {
            text: localize({ key: 'ReportSectionZeroState.selectTemplateButton.label' }),
            onPress: () => {
                onPressSelectTemplate === null || onPressSelectTemplate === void 0 ? void 0 : onPressSelectTemplate();
            },
        };
        const exploreSuggestionsButtonProps = {
            text: localize({ key: 'ReportSectionZeroState.exploreSuggestions.label' }),
            onPress: () => {
                onPressExploreSuggestions === null || onPressExploreSuggestions === void 0 ? void 0 : onPressExploreSuggestions();
            },
        };
        return (_jsx(ZeroState, { tokens: {
                text: {
                    color: dt.reportTokens.stateStandard.normal.fg,
                    fontSize: dt.reportTokens.font.size.h5,
                },
                heading: {
                    color: dt.reportTokens.stateStandard.normal.fg,
                    fontSize: dt.reportTokens.font.size.h5,
                },
            }, className: cn.zeroState, icon: ZeroStateReport, heading: localize({ key: 'ReportSectionZeroState.heading.label' }), text: localize({
                key: hideAutoChartButton
                    ? 'ReportSectionZeroState.hideAutoChartButton.description.label'
                    : 'ReportSectionZeroState.description.label',
            }), actionButtonOneProps: hideAutoChartButton ? templateButtonProps : autoChartButtonProps, actionButtonTwoProps: hideAutoChartButton ? undefined : templateButtonProps, actionButtonThreeProps: hideAutoChartButton ? undefined : exploreSuggestionsButtonProps }));
    }
    else {
        return (_jsx(ZeroState, { tokens: {
                text: {
                    color: dt.reportTokens.stateStandard.normal.fg,
                    fontSize: dt.reportTokens.font.size.h5,
                },
            }, className: cn.zeroState, text: localize({ key: 'ZeroState.viewMode.txt' }), icon: ZeroStateReport }));
    }
};
